export default {
    edit: 'Уреди',
    location: 'Локација + Услови',
    filter: 'Филтер',
};
